import { type TranslationType } from '@/lib/types';
import { type BannerCategoryType } from './types';

const EMPTY_BANNERS: BannerCategoryType = { LANDING: [], CASINO: [], SPORTSBOOK: [] };

export const getBannersFallback = async (
  t: TranslationType,
  tenantName: string,
  isMobile: boolean | null
): Promise<BannerCategoryType> => {
  try {
    switch (tenantName) {
      case 'vatan-game': {
        const { getVatanGameBanners } = await import('./tenants/vatan-game');
        return getVatanGameBanners(t, isMobile);
      }
      case 'hazarat-game': {
        const { getHazaratGameBanners } = await import('./tenants/hazarat-game');
        return getHazaratGameBanners(t, isMobile);
      }
      case 'skibet': {
        const { getSkiBetBanners } = await import('./tenants/skibet');
        return getSkiBetBanners(t, isMobile);
      }
      case 'asabet': {
        const { getAsaBetBanners } = await import('./tenants/asabet');
        return getAsaBetBanners(t, isMobile);
      }
      case 'gugul': {
        const { getGugulBanners } = await import('./tenants/gugul');
        return getGugulBanners(t, isMobile);
      }
      case 'xbet': {
        const { getXBetBanners } = await import('./tenants/xbet');
        return getXBetBanners(t, isMobile);
      }
      case 'betnana': {
        const { getBetnanaBanners } = await import('./tenants/betnana');
        return getBetnanaBanners(t, isMobile);
      }
      default: {
        console.warn(`Unsupported tenant: ${tenantName}, falling back to vatan-game`);
        const { getVatanGameBanners } = await import('./tenants/vatan-game');
        return getVatanGameBanners(t, isMobile);
      }
    }
  } catch (error) {
    console.error(`Failed to load banners for tenant ${tenantName}:`, error);
    // Return empty banners in case of error to prevent breaking the UI
    return EMPTY_BANNERS;
  }
};
